module.exports = __webpack_public_path__ + "img/img_policy_iso.e0658c05.jpg";